function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "info",
  transform: "translate(-1142.000000, -70.000000)",
  fill: "#3498DB",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1151.01406,76.9953127 L1151.01406,74.9765634 L1152.98594,74.9765634 L1152.98594,76.9953127 L1151.01406,76.9953127 Z M1146.31924,85.680762 C1147.91553,87.2457033 1149.80908,88.0281239 1152,88.0281239 C1154.19092,88.0281239 1156.06885,87.2457033 1157.63379,85.680762 C1159.23008,84.0844718 1160.02812,82.1909178 1160.02812,80 C1160.02812,77.8090822 1159.23008,75.9311526 1157.63379,74.3662113 C1156.06885,72.7699211 1154.19092,71.9718761 1152,71.9718761 C1149.80908,71.9718761 1147.91553,72.7699211 1146.31924,74.3662113 C1144.7543,75.9311526 1143.97188,77.8090822 1143.97188,80 C1143.97188,82.1909178 1144.7543,84.0844718 1146.31924,85.680762 Z M1144.91084,72.9578142 C1146.88262,70.9859381 1149.2457,70 1152,70 C1154.7543,70 1157.10176,70.9859381 1159.04219,72.9578142 C1161.01406,74.8982413 1162,77.2457033 1162,80 C1162,82.7542967 1161.01406,85.1173831 1159.04219,87.0891591 C1157.10176,89.0296863 1154.7543,90 1152,90 C1149.2457,90 1146.88262,89.0296863 1144.91084,87.0891591 C1142.97031,85.1173831 1142,82.7542967 1142,80 C1142,77.2457033 1142.97031,74.8982413 1144.91084,72.9578142 Z M1151.01406,85.0234366 L1151.01406,79.0140619 L1152.98594,79.0140619 L1152.98594,85.0234366 L1151.01406,85.0234366 Z",
  id: "Shape"
}))));

var SvgSuccess = function SvgSuccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/success.518e7fa4.svg";
export { ForwardRef as ReactComponent };